import apollo from 'apollo';
import { appsPerPage, clocksPerPage } from 'config';

import { AsyncActionHandler } from 'action-handler';
import { searchDeveloperAppsQuery } from 'queries';
import {
  createNormalizedMap,
  handleFetchError,
  getNextPageKey,
  updatePages,
  hasNextPage,
  pushApps
} from 'action-utils';
import { setSearchInput } from 'actions/gallery';

const STATE_PROP = 'searchDeveloperApps';

export default new AsyncActionHandler({
  name: 'search_developer_apps',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {},
    searchPages: {},
    apps: {}
  },
  handler({ developerName, developerProfileId, type, startIndex = 0 }) {
    return async (dispatch, getState) => {
      if (startIndex === 0) {
        dispatch(
          setSearchInput({
            developerName: developerName,
            developerProfileId: developerProfileId,
            userSetInput: true,
            type
          })
        );
      }

      if (!developerProfileId) {
        return;
      }

      const {
        [this.stateProp]: { [`${developerProfileId}-${type}`]: { pages } = {} }
      } = getState().registry;

      const pageKey = getNextPageKey({
        index: startIndex,
        pages
      });

      if (startIndex !== 0 && !pageKey) {
        return;
      }

      try {
        const { data: { searchResults } = {} } = await apollo.query({
          query: searchDeveloperAppsQuery,
          variables: {
            type,
            developerProfileId,
            limit: type === 'CLOCK' ? clocksPerPage : appsPerPage,
            pageKey
          },
          fetchPolicy: 'no-cache'
        });

        return {
          type,
          developerProfileId,
          searchResults,
          pageKey
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },

  reduce(state, { type, developerProfileId, searchResults, pageKey = 0 }) {
    const {
      [this.stateProp]: { [`${developerProfileId}-${type}`]: searchState = {} }
    } = state;

    if (!searchResults) {
      return state;
    }

    const existingApps = searchState.entries || [];
    const entries = pushApps(existingApps, searchResults.apps);

    const pages = updatePages({
      pageKey,
      pagedApps: searchResults,
      startIndex: existingApps.length,
      pages: searchState.pages
    });
    return {
      [this.stateProp]: {
        [`${developerProfileId}-${type}`]: {
          entries,
          hasNextPage: hasNextPage(pages),
          pages
        }
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(searchResults.apps, state.apps)
      }
    };
  }
});
